import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideAuthConfig } from './core/auth/auth.config';
import { routes } from './app.routes';
import { HttpAuthInterceptor } from './core/auth/http-auth-interceptor';
import { ConfigService } from './core/config/config-service';
import { configFactory, ConfigFactoryProvider } from './core/config/functions';
import { CareersAppSearchService } from './app-search/app-search.service';
import { APP_SEARCH_SERVICE_TOKEN } from './@theme/shared/components/app-search/app-search-config';
import { AppUserNotificationsService } from './app-user-notifications/app-user-notifications.service';
import { APP_USER_NOTIFICATIONS_SERVICE_TOKEN } from './@theme/shared/components/app-user-notifications/app-user-notifications-config';
import { provideRouter } from '@angular/router';
import { provideCoreConfig } from './core/core.config';
import { provideUIConfig } from './core/ui.config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideCoreConfig(),
    provideAuthConfig(),
    provideUIConfig(),

    { provide: HTTP_INTERCEPTORS, useClass: HttpAuthInterceptor, multi: true },

    provideAppInitializer(() => {
      const initializerFn = configFactory(inject(ConfigService));
      return initializerFn();
    }),
    {
      provide: 'API_URL', useFactory: ConfigFactoryProvider.getConfigFactory('api_url'), deps: [ConfigService],
    },
    {
      provide: APP_SEARCH_SERVICE_TOKEN, useClass: CareersAppSearchService,
    },
    {
      provide: APP_USER_NOTIFICATIONS_SERVICE_TOKEN, useClass: AppUserNotificationsService,
    },
    provideHttpClient(withInterceptorsFromDi())
  ]

}
